<template>
  <div class="text-center">
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      offset-y
      origin="center center"
      transition="scale-transition"
      bottom
      :nudge-width="100"
      :max-width="400"
      @input="refreshInput"
    >
      <template v-slot:activator="{ on, attrs }">
        <div class="portfolio-title" v-bind="attrs" v-on="on">
          <div class="row text-center">
            <template v-for="(item, index) in selectedPortfolioArray">
              <v-avatar v-if="assist.tool.isNotEmpty(item)" class="portfolio-avatar" tile :key="assist.tool.getRandomKey(index)">
                <img :src="item.icon" :alt="item.portfolioName">
              </v-avatar>
            </template>
          </div>
        </div>
      </template>

      <v-card width="400px" max-width="400px">
        <v-list two-line class="portfolio-card">
          <v-list-item-group
            v-model="selected"
            active-class="primary--text"
            multiple
          >
            <template v-for="(item, index) in portfolioList">
              <v-list-item :key="assist.tool.getRandomKey(index)">
                <template v-slot:default="{ active }">
                  <v-list-item-avatar>
                    <img
                      :src="item.icon"
                      :alt="item.icon"
                    >
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title v-text="item.portfolioName"></v-list-item-title>
                    <v-list-item-subtitle v-text="item.tribeName"></v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-icon
                      v-if="!active"
                      color="grey lighten-1"
                    >
                      check_circle
                    </v-icon>
                    <v-icon
                      v-else
                      color="primary"
                    >
                      check_circle
                    </v-icon>
                  </v-list-item-action>
                </template>
              </v-list-item>
              <v-divider
                v-if="index < portfolioList.length - 1"
                :key="assist.tool.getRandomKey(index)"
              ></v-divider>
            </template>
          </v-list-item-group>
        </v-list>
      </v-card>
    </v-menu>
  </div>
</template>
<script>
import { RuntimeApi } from '@/api/pandaria'
import { Tool, DataType } from '@/util/index'
import Cookies from 'js-cookie'

const tool = new Tool()
export default {
  name: 'portfolio-card',
  data: () => ({
    menu: false,
    companyId: 1,
    assist: {
      tool: tool,
      dataType: DataType
    },
    selected: [],
    portfolioList: [],
    selectedPortfolioArray: []
  }),
  mounted () {
    this.$eventBus.$on('updateAccount', target => {
      this.initPortfolioMenu()
    })
  },
  destroyed () {
    const lockReason = this.$store.getters.getLockReason
    if (lockReason !== this.assist.dataType.LockLoanReasonEnum.GENERATE_LOAN.value) {
      Cookies.set('portfolioSelected', '')
    }
  },
  methods: {
    initPortfolioMenu () {
      const $this = this
      let portfolioArray = $this.store.getters.getRuntimePortfolioArray
      const portfolioIdList = $this.$store.getters.getAccount.portfolioIdList
      if (tool.isEmpty(portfolioArray)) {
        portfolioArray = []
        RuntimeApi.listPortfolioParameterByCompanyId(this.companyId, function (result) {
          portfolioArray.push({})
          for (let i = 0; i < result.length; i++) {
            if (portfolioIdList.includes(result[i].portfolioId)) {
              portfolioArray.push(result[i])
            }
          }
          $this.setMenuList(portfolioArray)
          $this.store.commit('setRuntimePortfolioArray', portfolioArray)
        })
      } else {
        $this.setMenuList(portfolioArray)
      }
    },
    setMenuList (portfolioArray) {
      this.selected = []
      const runtimePortfolioId = []
      const runtimePortfolio = []
      const portfolioInCookie = tool.isNotEmpty(Cookies.get('portfolioSelected')) ? JSON.parse(Cookies.get('portfolioSelected')) : []
      for (let i = 0; i < portfolioArray.length; i++) {
        if (i !== 0 && (tool.isEmpty(portfolioInCookie) || portfolioInCookie.includes(portfolioArray[i].portfolioId))) {
          this.selected.push(i)
          runtimePortfolioId.push(portfolioArray[i].portfolioId)
          runtimePortfolio.push(portfolioArray[i])
        }
      }
      this.portfolioList = portfolioArray
      this.selectedPortfolioArray = runtimePortfolio
      this.$store.commit('setRuntimePortfolio', runtimePortfolioId)
      Cookies.set('portfolioSelected', runtimePortfolioId)
    },
    refreshInput () {
      const selected = this.selected
      const portfolioArray = this.portfolioList
      const newSelectedPortfolioArray = []
      const runtimePortfolio = []
      for (let i = 0; i < portfolioArray.length; i++) {
        if (selected.includes(i)) {
          newSelectedPortfolioArray.push(portfolioArray[i])
          if (i !== 0) {
            runtimePortfolio.push(portfolioArray[i].portfolioId)
          }
        }
      }
      this.selectedPortfolioArray = newSelectedPortfolioArray
      this.$store.commit('setRuntimePortfolio', runtimePortfolio)
      Cookies.set('portfolioSelected', runtimePortfolio)
    }
  }
}
</script>
<style lang="sass" scoped>
  .portfolio-title
    width: 420px
    height: 120%
    background-color: rgba(255, 255, 255, 0.27)
    .row
      display: flex
      justify-content: center
      position: relative
      top: 26%
      .portfolio-avatar
        margin-right: 5px
        margin-left: 5px
</style>
<style type="text/css">
  .portfolio-card .v-list-item:nth-child(1) {
    display: none!important;
  }
</style>
